"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaper = getPaper;
const svg_js_1 = require("@svgdotjs/svg.js");
function getPaper() {
    // eslint-disable-next-line new-cap
    return (0, svg_js_1.SVG)();
}
//# sourceMappingURL=getPaper.browser.js.map